var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCartBgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#004A2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 47C24.79 47 23.02 48.79 23.02 51C23.02 53.21 24.79 55 27 55C29.21 55 31 53.21 31 51C31 48.79 29.21 47 27 47ZM15 15V19H19L26.19 34.17L23.49 39.07C23.18 39.65 23 40.3 23 41C23 43.21 24.79 45 27 45H51V41H27.85C27.57 41 27.35 40.78 27.35 40.5C27.35 40.41 27.37 40.33 27.41 40.26L29.2 37H44.1C45.6 37 46.91 36.17 47.6 34.94L54.75 21.96C54.91 21.68 55 21.35 55 21C55 20.4696 54.7893 19.9609 54.4142 19.5858C54.0391 19.2107 53.5304 19 53 19H23.43L21.53 15H15ZM47 47C44.79 47 43.02 48.79 43.02 51C43.02 53.21 44.79 55 47 55C49.21 55 51 53.21 51 51C51 48.79 49.21 47 47 47Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartBgGreen);
export default __webpack_public_path__ + "static/media/IconCartBgGreen.e76bc83c189c18fea441d778d89da4e2.svg";
export { ForwardRef as ReactComponent };